export enum UserOsType {
  IOS = 'IOS',
  AOS = 'AOS',
  WEB = 'WEB',
}

export enum RegionType {
  KR = 'KR',
  EU = 'EU',
}

export enum BrandType {
  HYUNDAI = 'HYUNDAI',
  KIA = 'KIA',
  GENESIS = 'GENESIS',
}

export enum ThemeType {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
}

export enum DeviceType {
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
  PC = 'PC',
}

export enum DistanceUnitType {
  KM = 'KM',
  MILE_YARD = 'MILE_YARD',
  MILE_FEET = 'MILE_FEET',
}

export enum SpeedUnitType {
  KM_H = 'KM/H',
  MPH = 'MPH',
}
